import { render } from "./DoctorScheduled.vue?vue&type=template&id=2ed39fb5&scoped=true&ts=true"
import script from "./DoctorScheduled.vue?vue&type=script&lang=ts"
export * from "./DoctorScheduled.vue?vue&type=script&lang=ts"

import "./DoctorScheduled.vue?vue&type=style&index=0&id=2ed39fb5&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed39fb5"]])

export default __exports__